export enum APP_MODES {
    DEBUG = 'DEBUG'
}
